module.exports = __webpack_public_path__ + "bbb612589898b5d73490045f597f4bf3.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/svg/paw.svg
// module id = 430
// module chunks = 0